module.exports = {
    login_credentials_incorrect: "Anmeldeinformationen falsch"
  }